module.exports = __webpack_public_path__ + "static/img/nicee-2.3bb7ed88.png";